import MuiInputBase from "./MuiInputBase";
import MuiButton from "./MuiButton";
import MuiIconButton from "./MuiIconButton";
import MuiPaper from "./MuiPaper";
import MuiTableCell from "./MuiTableCell";
import MuiTableHead from "./MuiTableHead";
import MuiTypography from "./MuiTypography";
import MuiLink from "./MuiLink";
import MuiToolbar from "./MuiToolbar";
import MuiAppBar from "./MuiAppBar";
import MuiOutlinedInput from "./MuiOutlinedInput";

import SourceSansVariableRomanOtf from "../../fonts/SourceSansVariable-Roman.otf";

const bkfont = {
	fontFamily: "BkFont",
	fontStyle: "normal",
	fontDisplay: "swap",
	fontWeight: 400,
	src: `url(${SourceSansVariableRomanOtf}) format('otf')`,
	unicodeRange:
		"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export default {
	MuiButton,
	MuiIconButton,
	MuiPaper,
	MuiTableCell,
	MuiTableHead,
	MuiTypography,
	MuiLink,
	MuiToolbar,
	MuiAppBar,
	MuiInputBase,
	MuiOutlinedInput,
	MuiCssBaseline: {
		"@global": {
			"@font-face": [bkfont],
		},
	},
};
